export default "__VITE_ASSET__Bx68xtQ4__"